import { makeStyles } from '@material-ui/core/styles';
import type { TooltipProps } from '@material-ui/core/Tooltip';
import Tooltip from '@material-ui/core/Tooltip';
import HelpIcon from '@material-ui/icons/Help';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';
import React from 'react';

type HelpTipExtends = 'placement';

interface IProps extends Pick<TooltipProps, HelpTipExtends> {
  text: React.ReactNode;
  isNew?: boolean;
}

const HelpTip = ({ text, placement = 'top', isNew }: IProps) => {
  const useStyles = makeStyles((theme) => ({
    helpIcon: {
      color: !!isNew ? theme.palette.grey[500] : '#B0BEC5',
      fontSize: 18,
    },
  }));

  const classes = useStyles();

  return (
    <Tooltip title={text} placement={placement} arrow interactive>
      {!!isNew ? <HelpOutlineIcon className={classes.helpIcon} /> : <HelpIcon className={classes.helpIcon} />}
    </Tooltip>
  );
};

export default HelpTip;
